import { useEffect, useState } from "react";
import "./HelpPage.scss";
import { useNavigate } from "react-router-dom";
import { downloadIcon, IconoirEye } from "../../common/MotifIcons";
import { apiQueryToDownloadData, apiQueryToViewFile } from "../../common/services/apiBaseUrlConfig";
import { MotifToast } from "@ey-xd/motif-react";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import { decryptSasUri } from "../../common/utility/cryptoUtils";

export default function HelpPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isToastVisible, setIsToastVisible] = useState(false);
  const [isToastSuccess, setIsToastSuccess] = useState(false);
  const [toastTitle, setToastTitle] = useState("");
  const [toastMessage, setToastMessage] = useState("");

  const handleDownloadFAQ = async () => {
    setIsLoading(true);
    var response = await apiQueryToDownloadData.get(`${process.env.REACT_APP_API_URL_US}/api/support/faqs/download`);
    if (response && response.data) {
      const encryptedSasUri = response?.data?.encryptedSasUri;
      const fileName = response?.data?.fileName || "FAQs.pptx";
      if (encryptedSasUri) {
        const decryptedSasUri = decryptSasUri(encryptedSasUri);
        if (!decryptedSasUri) {
          setIsLoading(false);
          setIsToastVisible(true);
          setIsToastSuccess(false);
          setToastTitle("Download failed");
          setToastMessage("Unable to decrypt the file URL.");
          return;
        }
        fetch(decryptedSasUri)
          .then(res => res.blob())
          .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setIsLoading(false);
            setIsToastVisible(true);
            setIsToastSuccess(true);
            setToastTitle("Downloaded successfully");
            setToastMessage("FAQs have been downloaded.");
          })
          .catch((err) => {
            setIsLoading(false);
            setIsToastVisible(true);
            setIsToastSuccess(false);
            setToastTitle("Download failed");
            setToastMessage("Something went wrong while downloading the file.");            
          });        
      }
      else {
        setIsLoading(false);
        setIsToastVisible(true);
        setIsToastSuccess(false);
        setToastTitle("Download failed");
        setToastMessage("The file you are trying to download does not exist.");
      }      
    }
    else {
      setIsLoading(false);
      setIsToastVisible(true);
      setIsToastSuccess(false);
      setToastTitle("Download failed");
      setToastMessage("Something went wrong while downloading the file.");
    }    
  }

  const handleViewFAQ = async () => {      
      window.open('/faq-viewer', '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    if(isToastVisible){
      setTimeout(() => {
        setIsToastVisible(false);
        setIsToastSuccess(false);
        setToastTitle("");
        setToastMessage("");
      }, 5000);
    }
  }, [isToastVisible]);

  return (
    <>
    <div className="help-container" data-testid="help-container">
      <div className="help-header" data-testid="help-header">
        {/* <h1>Get help</h1>
        <p>
          Find quick answers to common questions or connect with our support team
          for more help.
        </p> */}
      </div>

      <div className="help-grid" data-testid="help-grid">
        {/* FAQs first */}
        <div className="help-card" data-testid="contact-card">
          <div onClick={(e) => {
            e.preventDefault();
            navigate(`/faq`)
          }}>
            <div className="image-block"><img src={require("../../common/images/chat-bubble-question.png")} alt="FAQ" /></div>
            <div className="card-row">
              <div>
                <div className="cardTitle">FAQs</div>
                <span className="sub">Looking for quick answers?</span>
              </div>
              <span className="arrow" >↗</span>
            </div>
            <p>
              Save time by exploring the most common queries – you might find exactly
              what you need!
            </p>
            </div>
            <div style={{ textAlign: "right" }}>
              {isLoading && <MotifProgressLoader show variant="default" />}
              <img src={downloadIcon} alt="Download" className="download-icon" onClick={(e) => { e.stopPropagation(); handleDownloadFAQ();}} />              
              <img src={IconoirEye} alt="View" className="view-icon" onClick={(e) => { e.stopPropagation(); handleViewFAQ();}} />
            </div>
        </div>        

        {/* Visit Discover card */}
        <div className="help-card" data-testid="faq-card" onClick={(e) => {
              e.preventDefault();
              window.open(
                "https://sites.ey.com/sites/DS_SaT/Pages/data-bureau-service-dbs.aspx",
                "_blank",
                "noopener,noreferrer"
              );
            }}>
          <div className="image-block"><img src={require("../../common/images/page-search.png")} alt="Visit Discover" /></div>
          <div className="card-row">
            <div>
              <div className="cardTitle">Visit Discover</div>
              <span className="sub"></span>
            </div>
            <span className="arrow" >↗</span>
          </div>
          <p>
            For additional information and resources please visit the
            {" "}
            <a
              href="https://sites.ey.com/sites/DS_SaT/Pages/data-bureau-service-dbs.aspx"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#2a73d9", fontWeight: 500 }}
            >
              DBS Discover Site
            </a>
          </p>
        </div>

        {/* Contact Us last in grid */}
        <div className="help-card" onClick={() => window.location.href = "mailto:DBS@parthenon.ey.com"}>
          <div className="image-block"><img src={require("../../common/images/mailOutlook.png")} alt="Contact Us" /></div>
          <div className="card-row">
            <div>
              <div className="cardTitle">Contact Us</div>
              <span className="sub"></span> 
            </div>
            <span className="arrow">↗</span>
          </div>
          <p style={{marginTop:"15px"}}>
            For requests or issues, contact the DBS team at <span> <a href="mailto:DBS@parthenon.ey.com" style={{ color: "#2a73d9", fontWeight: "500" }}>DBS@parthenon.ey.com</a></span>
          </p>
        </div>
      </div>
   
      <div className="help-footer">
        <div><div className="title">Support</div>
        <span className="desc">
          If you have any feedback, issues or ideas for improving DBS, drop your
          feedback by contact us option.
        </span>
        </div>
        <div className="left-footer">
        <div className="prv-title">Privacy Statement</div>
        <span className="desc">
        <p style={{lineHeight:1.1}}>  © 2025 EYGM Limited | All Rights Reserved. Content within this
          application is confidential and meant for EY staff and EY clients only.</p>
        </span>
        </div>
      </div>      
    </div>
    {isToastVisible && (
        <MotifToast
          variant={isToastSuccess ? 'success' : 'error'}
          className="get-help-toast"
          onClick={() => setIsToastVisible(false)}
          position="top"
          style={{ textAlign: 'left' }}
        >
          <div style={{ textAlign: 'left' }}>
            <strong>{toastTitle}</strong><br />
            {toastMessage}
          </div>
        </MotifToast>
      )}
    </>
  );
}
